import { useQuery, useQueryClient } from "@tanstack/react-query";
import { EndpointsService } from "../services/endpoints/endpoints.service";

export const useAppointmentsTypes = () => {
	const queryClient = useQueryClient();
	const queryKey = ["appointments-types"];

	const query = useQuery(queryKey, async () => {
		const response = await EndpointsService.appointments.getTypes();
		return response;
	});

	return {
		...query,
		invalidate: () => queryClient.invalidateQueries(queryKey),
	};
};
